export default __webpack_public_path__ + "static/media/donelle_buegge.50984bcb.png";